import { Component, ElementRef, EventEmitter, OnInit, Output } from "@angular/core";
import { trigger, state, style, transition, animate } from "@angular/animations";
import { HubUser } from "@appcore/models/user";
import { Router } from "@angular/router";
import { BehaviorSubject, Observable, Subscription } from "rxjs";
import { AuthenticationService, AuthorizationService } from "@appcore/service";

@Component({
  selector: "app-menu",
  templateUrl: "./app.menu.component.html",
  animations: [
    trigger("submenu", [
      state(
        "hidden",
        style({
          height: "0",
          overflow: "hidden",
          opacity: 0
        })
      ),
      state(
        "visible",
        style({
          height: "*",
          opacity: 1
        })
      ),
      transition("* <=> *", animate("400ms cubic-bezier(0.86, 0, 0.07, 1)"))
    ])
  ]
})
export class AppMenuComponent implements OnInit {
  @Output() menuGroupClick = new EventEmitter();
  activeMenuId: string;
  activeSubmenus: { [key: string]: boolean } = {};
  filteredRoutes: any[];
  @Output() menuActive = false;
  scrollable = true;
  selectedRoute: any;
  submenuRouting: boolean;
  subscription: Subscription;

  // User Elements
  isAuthenticated: BehaviorSubject<boolean>;
  userRoles: string;

  // Security Levels
  sysAdminAccess: Observable<boolean>;
  adminAccess: Observable<boolean>;
  standardUser = false;

  appcontent: Observable<boolean>;
  products: Observable<boolean>;
  productLines: Observable<boolean>;
  assessments: Observable<boolean>;
  standardReports: Observable<boolean>;
  jaice: Observable<boolean>;
  marketingMaterials: Observable<boolean>;
  organizationManager: Observable<boolean>;
  adminProductExporter: Observable<boolean>;
  learnerRecords: Observable<boolean>;
  componentSearch: Observable<boolean>;
  serviceMessaging: Observable<boolean>;
  systemConfiguration: Observable<boolean>;
  systemTools: Observable<boolean>;
  systemSecurity: Observable<boolean>;

  constructor(private el: ElementRef, private router: Router, private authenticationService: AuthenticationService,
    private authorizationService: AuthorizationService) { }

  ngOnInit(): void {
    this.populateUserInfo();
  }

  populateUserInfo(): void {
	this.authenticationService.getCurrentUserValue().subscribe((currentUser) => {
		this.isAuthenticated = this.authenticationService.$authed;
		console.log("Populating User Info & Checking Permissions");
		this.userRoles = currentUser.Groups as string;
	
		this.adminAccess = this.authorizationService.validateGroup(currentUser.ID, 'PLS-Admin');
		this.sysAdminAccess = this.authorizationService.validateGroup(currentUser.ID, 'System-Administrator');
	
		this.appcontent = this.authorizationService.validatePermission(currentUser.ID, 'App Content');
		this.products = this.authorizationService.validatePermission(currentUser.ID, 'Products');
		this.productLines = this.authorizationService.validatePermission(currentUser.ID, 'Product Lines');
		this.assessments = this.authorizationService.validatePermission(currentUser.ID, 'Assessments');
		this.standardReports = this.authorizationService.validatePermission(currentUser.ID, 'Standard Reports');
		this.jaice = this.authorizationService.validatePermission(currentUser.ID, 'JAICE');
		this.marketingMaterials = this.authorizationService.validatePermission(currentUser.ID, 'Marketing Materials');
		this.organizationManager = this.authorizationService.validatePermission(currentUser.ID, 'Organization Manager');
		this.adminProductExporter = this.authorizationService.validatePermission(currentUser.ID, 'Admin Product Exporter');
		this.learnerRecords = this.authorizationService.validatePermission(currentUser.ID, 'Learner Records Management');
		this.componentSearch = this.authorizationService.validatePermission(currentUser.ID, 'Component Search');
		this.serviceMessaging = this.authorizationService.validatePermission(currentUser.ID, 'Service Messaging');
		this.systemConfiguration = this.authorizationService.validatePermission(currentUser.ID, 'System Configuration');
		this.systemTools = this.authorizationService.validatePermission(currentUser.ID, 'System Tools');
		this.systemSecurity = this.authorizationService.validatePermission(currentUser.ID, 'System Security');
	
		if (this.userRoles.includes("PLS_Hub_StandardUsers")) {
			this.standardUser = true;
		} else {
			console.log("-- Unprivileged User Access --");
		}
	});
  }

  onMenuButtonClick(event: Event): void {
    this.menuActive = !this.menuActive;
    if (!this.menuActive) {
      this.activeMenuId = "";
    }
    event.preventDefault();
  }

  openMenu(): void {
    this.menuActive = true;
  }

  closeMenu(): void {
    this.menuActive = false;
    this.activeMenuId = "";
  }

  onMenuGroupClick(event: Event, elementName: string): void {
    this.menuGroupClick.emit(true);
    this.activeMenuId = this.activeMenuId === elementName ? "" : elementName;
    if (this.activeMenuId == "") {
      this.closeMenu();
    } else {
      this.openMenu();
    }
    event.preventDefault();
  }

  onMenuItemClick(event: Event, routerArgs?: []): void {
    this.router.navigate(routerArgs);
    this.menuActive = false;
    this.activeMenuId = "";
    event.preventDefault();
  }
}
